class LazyLoad {
    constructor(element, offset = 100, loadCallback, direction = "down") {
        this.element = $(element);
        this.offset = offset;
        this.loadCallback = loadCallback;
        this.isFetching = false;
        this.direction = direction;
        this.throttleTimer = null;
        this.errorFlag = false;
    }

    watch() {
        // Attach the scroll event listener
        this.element.on("scroll", () => {
            if (this.throttleTimer) {
                clearTimeout(this.throttleTimer);
            }

            this.throttleTimer = setTimeout(() => {
                this.checkScrollPosition();
            }, 100);
        });
    }

    checkScrollPosition() {
        if (this.isFetching || this.errorFlag) {
            return;
        }

        var scrollTop = (this.element[0] === window) ? $(window).scrollTop() : this.element.scrollTop();
        var innerHeight = (this.element[0] === window) ? $(window).height() : this.element.innerHeight();
        var scrollHeight = (this.element[0] === window) ? $(document).height() : this.element[0].scrollHeight;

        if ((this.direction === 'down' && scrollTop + innerHeight >= scrollHeight - this.offset) ||
            (this.direction === 'up' && scrollTop <= this.offset)) {
            this.isFetching = true;
            this.loadCallback()
            .then(() => {
                this.isFetching = false;
            })
            .catch((error) => {
                this.isFetching = false;
                this.errorFlag = true;
            });
        }
    }

    resetWatch() {
        this.errorFlag = false;
    }

    stop() {
        this.element.off('scroll');
    }
}
